import { InputAdornmentButton } from '@cian/ui-kit';
import { FC } from 'react';
import { useSelector } from 'react-redux';
import { selectHasUnderground } from 'shared/selectors/location';
import { UndergroundMapModalContainer } from '../MapModalContainer';
import { useModalState } from 'shared/hooks';

export const UndergroundPopupButtonContainer: FC = () => {
  const hasUnderground = useSelector(selectHasUnderground);

  const { opened, onClose, onOpen } = useModalState();

  if (!hasUnderground) {
    return null;
  }

  return (
    <>
      <InputAdornmentButton
        data-testid="UndergroundPopupButton"
        data-name="UndergroundPopupButtonContainer"
        type="button"
        onClick={onOpen}
      >
        Метро
      </InputAdornmentButton>
      {opened && <UndergroundMapModalContainer onModalClose={onClose} />}
    </>
  );
};
